import { useQuery } from '@tanstack/react-query';
import { IStatsResponse } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetExtendedStats = () =>
  useQuery({
    queryKey: ["get_extended_stats"],
    queryFn: async (): Promise<IStatsResponse> => {
      const res = await apiClient.get(ENDPOINTS.DASHBOARD.GET_EXTENDED_STATS);
      return res.data;
    },
  });
